import React from 'react';
import Button from '@material-ui/core/Button';
import mainClasses from './Enrollment.css.js';
import Eligibility from './Eligibility';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Popover from '@material-ui/core/Popover';
import { createMuiTheme } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import SetupFamily from './SetupFamily';
import PlanSelection from './PlanSelection';
import SubmitApplication from './SubmitApplication';
import { connect } from 'react-redux';
import Tooltip from '@material-ui/core/Tooltip';
import configuration from '../../../configurations';
import axios from 'axios';
import Loader from '../../loader';
import moment from 'moment'
import customStyle from '../../../Assets/CSS/stylesheet_UHS';
import i18n from '../../../i18next';
import Header from '../Headers/Header';
import { Auth } from "aws-amplify";
import ChatButton from "../../CommonScreens/ChatButton";
import Fab from "@material-ui/core/Fab";
import Configuration from "../../../configurations";
import Cookies from 'universal-cookie';
import {getPublicIP} from '../../authentication/utils';
import AddOnsScreen from "./Add-ons/addOnsScreen";
import ReviewChoice from './ReviewChoice/ReviewChoice'
import EnrollmentSummary from './EnrollmentSummary'
import configurations from '../../../configurations';
import { copyrightText, version } from '../../../UHFAgenCDN.js';

global.Chat=0;


const StyleTooltip = withStyles({
    tooltip: {
      color: "#000000",
      backgroundColor: "#ffffff",
      fontSize:'14px',
      textAlign:'left',
    //   width:'180px'
    }
  })(Tooltip);

const CustomTextField = withStyles(
    customStyle.textField,
)(TextField);

const CustomButton = withStyles(
    customStyle.btn,
)(Button);

const WizardButton = withStyles(
    customStyle.viewBtn
)(Button);

const CrudButton = withStyles(
    customStyle.crudBtn,
)(Fab);

const styles = theme => (
    customStyle.defaultStyle
);
const theme = createMuiTheme({
    spacing: 4
  });

const cookies = new Cookies();

class Enrollment extends React.Component {
    constructor(props) {
        super(props);
        // Set true once getStepperStatus() resolves, so the legacy completionStatus-based
        // activeStep logic in getEnrollFlag becomes a no-op for activeStep specifically.
        this._stepperInitialStepDecided = false;
        this.state = {
            activeStep: 0,
            completed: {},
            modalOpen: false,
            optReason: '',
            otherReason: '',
            currentUser: '',
            info:[],
            formValid: true,
            optReasonList: [],
            loaderShow: false,
            errorText : '',
            isValid : false,
            isReasonsReq : true,
            optFlag:false,
            disOtReason : true,
            userLoggedIn : false,
            anchorEl: null, open: false,
            openedPopoverId:null,
            enrollFlag : false,
            paymentFlag : false,
            isAgent : false,
            STATE_PARAM : {},
            agentLoggedIn : false,
            notAuthorisedPerson : false,
            notHL: null,
            isChangeProgram:false,
            ChangeProgramCount: [],
            isHouseholdUpdate:false,
            HouseholdUpdateCount: [],
            reenrollmentFlag:false,
            isEmployer: false,
            showEnrollmentSummary: true,
            enrollingStepperType: null,
        };
        this.checkForAddOnStep= this.checkForAddOnStep.bind(this)
    }

    getSteps() {
        let cookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM'));
        const familyLabel = cookiesData && (cookiesData.clientId == '5742' || cookiesData.clientId == '4599') ? 'Set up Member' : 'Set up Family';
        if (this.state.notHL) {
          return [
            familyLabel,
            "Select Program",
            "Select Add-Ons",
            "Check Eligibility",
            "Review Choices",
            "Submit Application",
          ];
        }
        return [
            familyLabel,
            'Select Program',
            'Review Choices',
            'Submit Application'
        ]

    };

    // Named step indices for the flow: Setup Family, Select Program, Select Add-Ons (when notHL),
    // Check Eligibility, Review Choices, Submit Application.
    getStepIndex = (name) => {
        const indices = this.state.notHL
            ? { SETUP_FAMILY: 0, SELECT_PROGRAM: 1, SELECT_ADDONS: 2, CHECK_ELIGIBILITY: 3, REVIEW_CHOICES: 4, SUBMIT_APPLICATION: 5 }
            : { SETUP_FAMILY: 0, SELECT_PROGRAM: 1, REVIEW_CHOICES: 2, SUBMIT_APPLICATION: 3 };
        return indices[name];
    };

    // Reverse of getStepIndex — the step name for a given activeStep index, used to report
    // which step the member just completed to the stepper-save API.
    getStepName = (index) => {
        const indices = this.state.notHL
            ? { SETUP_FAMILY: 0, SELECT_PROGRAM: 1, SELECT_ADDONS: 2, CHECK_ELIGIBILITY: 3, REVIEW_CHOICES: 4, SUBMIT_APPLICATION: 5 }
            : { SETUP_FAMILY: 0, SELECT_PROGRAM: 1, REVIEW_CHOICES: 2, SUBMIT_APPLICATION: 3 };
        return Object.keys(indices).find((name) => indices[name] === index);
    };

    // Saves progress on the member stepper, then notifies the agency SSE channel.
    // subId here is a session identifier (STATE_PARAM.subID / user_subId), not an email address.
    // Carrier drives which stepper this session belongs to: "Sharing Programs" => UHF, "Insurance Plans" => VERA.
    getStepperType = (cookiesData) => {
        return cookiesData.actionType;
    };

    saveStepperProgress = (stepIndex) => {
        let cookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM')) || {};
        let memberId = cookiesData.memberId;
        let subId = cookiesData.subID || cookiesData.user_subId;
        let stepCode = this.getStepName(stepIndex);
        let stepperType = this.getStepperType(cookiesData);
        if (!memberId || !subId || !stepCode) return;

        let now = moment().format('YYYY-MM-DDTHH:mm:ss');
        axios.post(configuration.baseRootUrl + '/veraenroll/api/v1/enrollment/stepper/memberstepper', {
            id: memberId,
            subId: subId,
            stepperType: stepperType,
            stepCode: stepCode,
            createdDate: now,
            updatedDate: now,
        })
        .then(() => {
            axios.post(configuration.baseRootUrl + '/veraagency/sse/send/event', {
                email: subId,
                name: 'Enrollment Portal',
                status: 'Stepper',
            }).catch((error) => console.log(error));
        })
        .catch((error) => console.log(error));
    };

    // Records that a prospect successfully accessed the Enrollment Portal via their auth
    // link (Cognito login), then notifies the agency SSE channel — mirrors saveStepperProgress's
    // notify-then-SSE pattern above.
    notifyAuthLinkAccessed = (subId, stepperType) => {
        if (!subId) return;
        axios.post(configuration.baseRootUrl + '/veraenroll/api/v1/enrollment/stepper/authLinkAccessed/' + subId + '/' + stepperType)
            .then(() => {
                axios.post(configuration.baseRootUrl + '/veraagency/sse/send/event', {
                    email: subId,
                    name: 'Enrollment Portal',
                    status: 'Stepper',
                }).catch((error) => console.log(error));
            })
            .catch((error) => console.log(error));
    };

    // Enters Submit Application for the specific carrier/product the member clicked ENROLL
    // against, from the Enrollments summary. STATE_PARAM.actionType drives which carrier's
    // context SubmitApplication and its downstream API calls use, so it's updated to that
    // product's stepperType (in addition to passing it directly as a prop) before switching.
    handleEnrollProduct = (row) => {
        console.log('handleEnrollProduct', row);
        let STATE_PARAM = JSON.parse(sessionStorage.getItem('STATE_PARAM')) || {};
        if (row && row.stepperType) {
            STATE_PARAM.actionType = row.stepperType;
            STATE_PARAM.carrier = row.carrier;
            STATE_PARAM.productName = row.productName;
            sessionStorage.setItem('STATE_PARAM', JSON.stringify(STATE_PARAM));
        }
        this.notifyAuthLinkAccessed(STATE_PARAM.subID, row.stepperType);
        this.setState({
            showEnrollmentSummary: false,
            enrollingStepperType: row && row.stepperType,
        });
    };

    // Resolves which step to resume on. No record (new member / not started) => Setup Family;
    // otherwise navigate straight to the stepCode the backend last saved.
    // This is the single source of truth for the initial activeStep — see _stepperInitialStepDecided,
    // which makes the legacy completionStatus-based activeStep assignments in getEnrollFlag a no-op.
    getStepperStatus = () => {
        let cookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM')) || {};
        let subId = cookiesData.subID || cookiesData.user_subId;
        let stepperType = this.getStepperType(cookiesData);

        const resolveToSetupFamily = () => {
            this._stepperInitialStepDecided = true;
            this.setState({ activeStep: this.getStepIndex('SETUP_FAMILY') });
        };

        if (!subId) {
            resolveToSetupFamily();
            return;
        }
        if(stepperType)
        axios.get(configuration.baseRootUrl + '/veraenroll/api/v1/enrollment/stepper/' + subId + '/' + stepperType)
            .then((response) => {
                let stepCode = response.data && response.data.stepCode;
                if (!stepCode) {
                    resolveToSetupFamily();
                    return;
                }
                // Defensive fallback: this method is now only called from checkForAddOnStep once
                // notHL is confirmed (see there), so this branch shouldn't normally trigger. Kept
                // in case getStepperStatus is ever invoked before notHL is known again — SELECT_ADDONS
                // only exists in the notHL step-index map, and the backend wouldn't have saved this
                // stepCode unless add-ons were genuinely available, so it's safe to force notHL true
                // here rather than let getStepIndex return undefined and bounce to Setup Family.
                if (stepCode === 'SELECT_ADDONS' && !this.state.notHL) {
                    this.setState({ notHL: true }, () => {
                        this._stepperInitialStepDecided = true;
                        this.setState({ activeStep: this.getStepIndex('SELECT_ADDONS') });
                    });
                    return;
                }
                let stepIndex = this.getStepIndex(stepCode);
                if (stepIndex === undefined) {
                    resolveToSetupFamily();
                    return;
                }
                this._stepperInitialStepDecided = true;
                this.setState({ activeStep: stepIndex });
            })
            .catch(() => resolveToSetupFamily());
    };

    flipOpen = () => this.setState({ ...this.state, open: !this.state.open });
    handleClick = event => {
      this.state.ancherEl
        ? this.setState({ anchorEl: null })
        : this.setState({ anchorEl: event.currentTarget });
      this.flipOpen();
    };

    handlePopoverOpen(event, popoverId) {
        this.setState({
          openedPopoverId: popoverId,
          anchorEl: event.target,
        });
    }

    handlePopoverClose() {
        this.setState({
          openedPopoverId: null,
          anchorEl: null,
        });
    }

    autoLoginreEnrollCheck=(data)=>{
        let URLs=Configuration.baseUrl + '/setupfamily/getEnrollFlag/' + data;
        let autoLogin = sessionStorage.getItem("autoLogin");
        axios.get(URLs)
        .then(response => {
            if((response.data.response.enrollFlag === true || response.data.response.enrollFlag === 'true') && (autoLogin === true || autoLogin === "true")){
                 sessionStorage.setItem("reenrollmentFlag", response.data.response.enrollFlag);
                 this.setState({isHouseholdUpdate:true})
                    axios.get(Configuration.baseUrl + '/setupfamily/getMemberInfo/' + response.data.response.subId)
                    .then(res => {
                    if (res && res.data.response) {
                        let data = res.data.response;
                        let obj={
                        memberId: data.id,
                        reenrollmentFlag: response.data.response.enrollFlag,
                        brokerId: response.data.response.brokerId,
                        fromLogin: true,
                        subID: response.data.response.subId
                        }
                            sessionStorage.setItem('STATE_PARAM', JSON.stringify(obj));
                        }
                    })
                        
                    }
          })  
    }
    componentDidMount() {
        window.addEventListener('SubmitApl',this.SubmitApplictaion);
        window.addEventListener('enroll_flag',this.enrollment);
        window.addEventListener('paymentFlag',this.payment);
        window.scrollTo(0,0)
        getPublicIP();
        this.setState({
            loaderShow: true
        });
        let isAgent
        let cookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM'))//cookies.get('STATE_PARAM', false);
        //console.log("cookiesData----",cookiesData)
        // getStepperStatus() is now called from checkForAddOnStep once notHL is known — see there
        // for why calling it independently here raced notHL and could resume on the wrong step.
        if(cookiesData && cookiesData.isSelectProgram){
            this.setState({isChangeProgram:true}) // for go to step select program
        }
        if(cookiesData && cookiesData.isHouseholdUpdate){
            this.setState({isHouseholdUpdate:true}) // for go to setup family
        }
        if(cookiesData && cookiesData.empid){
            this.setState({isEmployer:true}) // Employer flow: Check Eligibility step is disabled
        }
       this.autoLoginreEnrollCheck(sessionStorage.getItem("userMail"));
        if(cookiesData && cookiesData.isAgent || cookiesData && cookiesData.fromMember){
            // isAgent=true
            this.setState({
                agentLoggedIn : true,
                userLoggedIn : false,
                isAgent : true
            });
            let URL=''
            let subId=localStorage.getItem("cognitoUsername")
            if(cookiesData.isAgent){
                URL=configuration.baseUrl + '/setupfamily/getMemberBySubID/'+cookiesData.subID
            }else{
                URL=configuration.baseUrl + '/setupfamily/getMemberByEmail/'+cookiesData.user_subId
            }
            axios.get(URL)
                .then(response => {
                    if(response.data.response){
                        let data = JSON.parse(JSON.stringify(response.data.response));
                        const { prefix, firstName, middleName, lastName, suffix } = data;
                        const displayName = `${prefix || ""} ${firstName || ""} ${middleName || ""} ${lastName || ""} ${suffix || ""}`;
                        this.setState({
                            currentUser : displayName
                        });
                        this.props.setSubId(data.subId, data.email, data.firstName + ' ' + data.lastName);
                        let obj = {
                            userName: data.firstName + ' ' + data.lastName,
                            id: data.subId,
                            groupId: data.groupId,
                            email: data.email,
                            phone : data.phone,
                        };
                        localStorage.setItem('CurrentLoginUser', JSON.stringify(obj));
                        sessionStorage.setItem('userMail', data.email);
                    }
                    this.getEnrollFlag(cookiesData.user_subId);
                });
        } else {
            Auth.currentAuthenticatedUser()
                .then((user) => {
                    let data = this.parseJwt(user.signInUserSession.idToken.jwtToken);
                    this.getUserDataByEmail(data);
                    let currentUser = localStorage.getItem('currentUser');
                    this.setState({
                        currentUser: currentUser,
                        userLoggedIn: true,
                        agentLoggedIn : false,
                        isAgent : false
                    });
                    sessionStorage.setItem('isAgent', "false");
                    let STATE_PARAM = JSON.parse(sessionStorage.getItem('STATE_PARAM'));//cookies.get('STATE_PARAM', false);
                    let cl = sessionStorage.getItem('CLIENT_ID');
                    if(STATE_PARAM && !cl){
                        console.log('state - - -', STATE_PARAM);
                        let emailData = JSON.parse(localStorage.getItem('CurrentLoginUser'));
                        let phone = localStorage.getItem('phone');

                        let obj = new Object();
                        obj.email = emailData.email;
                        obj.phone = phone;
                        obj.brokerId = STATE_PARAM.brokerId;
                        obj.associationId = STATE_PARAM.associationId;
                        obj.clientId = STATE_PARAM.clientId;
                        obj.subId = emailData.id;
                        obj.userName = emailData.userName;
                        obj.empid = STATE_PARAM.empid ? STATE_PARAM.empid : null;
                        console.log("addMemberInfo===getEnrollFlag",obj)
                        axios.post(Configuration.baseUrl + '/setupfamily/addMemberInfo', obj)
                            .then(response => {
                                sessionStorage.setItem('subId', JSON.stringify(response.data.response.subId))
                                this.getEnrollFlag(data);
                            });
                    } else {
                        this.getEnrollFlag(data);
                    }

                }).catch((err)=>{
                sessionStorage.setItem('isLogged', false);
                this.props.history.push("/login");
                this.setState({
                    loaderShow: false,
                    userLoggedIn: false
                })
            })
        }
    }

   // Add-Ons only exist for the current carrier (e.g. UHF "Sharing Programs") — derive notHL
   // from the same carriers/plans response the Select Add-Ons screen itself consumes, rather
   // than the legacy per-client addon list, so gating and the screen agree on one source of truth.
   checkForAddOnStep=(clientId, subId, brokerId)=>{
    let cookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM')) || {};
    // Carrier (not actionType, which is the product type — see SetupFamily.js's
    // carrierCode=STATE_PARAM.carrier / productType=STATE_PARAM.actionType split) drives which
    // carrier this session belongs to. Matches the same derivation PlanSelection.js and
    // addOnsScreen.js use for this same carriers-list API, so the carrier lookup here actually
    // finds the carrier the member is enrolling in — using actionType here (as before) meant
    // this never matched anything, so the Add-Ons step could never show.
    let carrierCode = cookiesData.carrier || 'UHF';
    // Add-Ons are a UHF ("Sharing Programs") concept only — other carriers (e.g. VERA insurance
    // plans) never get this step, even if their data happened to carry an "Addon" plan entry.
    let isUHF = carrierCode === 'UHF';
    if (!subId || !brokerId) {
        // notHL can't be determined without these — resolve the resume step anyway rather
        // than leaving getStepperStatus() waiting forever.
        this.getStepperStatus();
        return;
    }
    axios.get(configurations.baseRootUrl + '/veraenroll/api/v1/quote/agent/' + brokerId + '/carriers?subId=' + subId)
    .then(response=>{
        // Response is a flat array of carriers (not wrapped in {carriers: [...]})  — each carrier
        // groups its core plans under types[].plans, and carries its own add-ons in a SEPARATE
        // top-level "addons" array (add-ons are NOT mixed into plans / flagged via programType
        // there — that only happens on the addons entries themselves, which live elsewhere).
        let carriers = Array.isArray(response.data) ? response.data : ((response.data && response.data.carriers) || []);
        let carrier = carriers.find(c => c.carrierCode === carrierCode);
        const notHL = isUHF && !!(carrier && carrier.addons && carrier.addons.length > 0);
        this.setState({
            notHL: notHL,
            // Change-Program: jumpable from Select Add-Ons onward (or Select Program onward when
            // there are no add-ons — that shorter flow also skips Check Eligibility, same as notHL).
            ChangeProgramCount: notHL ? [2, 3, 4, 5] : [1, 2, 3],
            // Household-Update: every step is jumpable (Setup Family is always the first step now).
            HouseholdUpdateCount: notHL ? [0, 1, 2, 3, 4, 5] : [0, 1, 2, 3],
        }, () => {
            // getStepIndex(stepCode) depends on notHL to know which step list is in play (e.g.
            // Check Eligibility is index 2 without add-ons, 3 with them) — resolving the resume
            // step here, only after notHL is confirmed, is what stops a refresh from landing on
            // the wrong step (previously a race against this same call could land on whichever
            // step happens to share the stale, wrong-branch index).
            this.getStepperStatus();
        })
        sessionStorage.setItem("notHLC", notHL)
    })
    .catch(error => {
        console.log(error)
        this.getStepperStatus();
    })

   }

    getEnrollFlag = (data) => {        
        let URL=''
        let cookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM'))
        if(this.state.isAgent){
            URL=configuration.baseUrl + '/setupfamily/getEnrollFlagBySubId/'+cookiesData.subID
        }else{
            URL=configuration.baseUrl + '/setupfamily/getEnrollFlag/' + data
        }
        axios.get(URL)
            .then(response => {
                if(response.data.response){
                    let enFlag = response.data.response.enrollFlag;
                    let paymentFlag = response.data.response.paymentFlag;
                    let completionStatus = response.data.response.completionStatus;
                    let clientId = response.data.response.clientId;
                    let chatBoxId = response.data.response.chatBoxId;
                    let agentFlag = response.data.response.agentFlag;
                    let reenrollmentFlag = response.data.response.reenrollmentFlag

                    localStorage.setItem('subId', response.data.response.subId);
                    sessionStorage.setItem('EMP_NAME', (response.data.response && response.data.response.companyName )? response.data.response.companyName : '');

                    this.setState({
                        STATE_PARAM : {
                            brokerId : response.data.response.brokerId,
                            associationId : response.data.response.associationId,
                            clientId : response.data.response.clientId,
                            subID: response.data.response.subId,
                            fromMember: false,
                            reEnrolledByAgent: false,
                            empid : response.data.response.empId ? response.data.response.empId : null,
                         
                        },
                        isEmployer: response.data.response.empId  ? true : false,
                        reenrollmentFlag : response.data.response.reenrollmentFlag,
                    }, () => {
                        if (!cookiesData) {
                            sessionStorage.setItem('STATE_PARAM', JSON.stringify(this.state.STATE_PARAM));
                        }
                    });

                    if(!this.state.isAgent){
                        if(!clientId){
                            sessionStorage.setItem('CHAT_BOX_Id', configuration.chat_Box_Id);
                            window.location.reload();
                        } else if(clientId){
                            if(sessionStorage.getItem('CHAT_BOX_Id')){
                                if(sessionStorage.getItem('CHAT_BOX_Id') === null){
                                    sessionStorage.setItem('CHAT_BOX_Id', chatBoxId);
                                    window.location.reload();
                                }
                            } else {
                                sessionStorage.setItem('CHAT_BOX_Id', chatBoxId);
                                window.location.reload();
                            }
                        }
                        // this.notifyAuthLinkAccessed(response.data.response.subId, (cookiesData && cookiesData.actionType) || 'UHF');
                    }
                    this.checkForAddOnStep(clientId, response.data.response.subId, response.data.response.brokerId);
                    sessionStorage.setItem('CLIENT_ID', clientId)
                    if(this.state.isChangeProgram){
                        this.setState({
                            activeStep: this._stepperInitialStepDecided ? this.state.activeStep : (this.getStepIndex('SELECT_PROGRAM') + 1), // step right after Select Program (Select Add-Ons if available, else Check Eligibility)
                            loaderShow: false,
                            /*optFlag:true,*/
                            enrollFlag: enFlag,
                            paymentFlag : paymentFlag,
                        });
                    }
                    else if(this.state.isHouseholdUpdate){
                        this.setState({
                            activeStep: this._stepperInitialStepDecided ? this.state.activeStep : ((enFlag === true && !this.state.isAgent) ? parseInt(completionStatus): this.getStepIndex('SETUP_FAMILY')),
                            loaderShow: false,
                            /*optFlag:true,*/
                            enrollFlag: enFlag,
                            paymentFlag : paymentFlag,
                        });
                    }
                    else if(sessionStorage.getItem('isEditCensus') == true || sessionStorage.getItem('isEditCensus') == 'true'){

                        //sessionStorage.setItem('prev_current_screen', completionStatus);
                        sessionStorage.setItem('current_screen', String(this.getStepIndex('SETUP_FAMILY')));
                        this.setState({
                            activeStep: this._stepperInitialStepDecided ? this.state.activeStep : (this.getStepIndex('SETUP_FAMILY')),
                            loaderShow: false,
                            /*optFlag:true,*/
                            enrollFlag: enFlag,
                            paymentFlag : paymentFlag
                        });

                    } else {

                        if (enFlag === false && paymentFlag === false && completionStatus === '0') {
                            sessionStorage.setItem('current_screen', String(this.getStepIndex('SETUP_FAMILY')));
                            this.setState({
                                loaderShow: false,
                                enrollFlag: enFlag,
                                paymentFlag : paymentFlag,
                                activeStep: this._stepperInitialStepDecided ? this.state.activeStep : (this.getStepIndex('SETUP_FAMILY')),
                            });
                        } else if(!paymentFlag && enFlag){
                            // Payment is no longer collected in this flow; land on the final step instead.
                            this.setState({
                                activeStep: this._stepperInitialStepDecided ? this.state.activeStep : (this.getStepIndex('SUBMIT_APPLICATION')),
                                loaderShow: false,
                                enrollFlag: enFlag,
                                paymentFlag : paymentFlag
                            });
                        } else if(completionStatus) {
                            if(completionStatus === '6' && !enFlag && !paymentFlag){
                                this.setState({
                                    activeStep: this._stepperInitialStepDecided ? this.state.activeStep : (this.getStepIndex('SUBMIT_APPLICATION')),
                                    loaderShow: false,
                                    enrollFlag: enFlag,
                                    paymentFlag : paymentFlag
                                });

                            } else if(!enFlag && !paymentFlag){
                                this.setState({
                                    activeStep: this._stepperInitialStepDecided ? this.state.activeStep : (parseInt(completionStatus)),
                                    loaderShow: false,
                                    /*optFlag:true,*/
                                    enrollFlag: enFlag,
                                    paymentFlag : paymentFlag
                                });
                            }else if(enFlag && paymentFlag && reenrollmentFlag ){
                                this.setState({
                                    activeStep: this._stepperInitialStepDecided ? this.state.activeStep : (parseInt(completionStatus)),
                                    loaderShow: false,
                                    /*optFlag:true,*/
                                    enrollFlag: enFlag,
                                    paymentFlag : paymentFlag
                                });
                            } else {
                                const steps = this.getSteps().length;
                                this.setState({
                                    activeStep: this._stepperInitialStepDecided ? this.state.activeStep : (completionStatus),
                                    loaderShow: false,
                                    /*optFlag:true,*/
                                    enrollFlag: enFlag,
                                    paymentFlag : paymentFlag
                                });
                            }
                        } else {
                            const steps = this.getSteps().length;
                            this.setState({
                                activeStep: this._stepperInitialStepDecided ? this.state.activeStep : (steps - 1),
                                loaderShow: false,
                                /*optFlag:true,*/
                                enrollFlag: enFlag,
                                paymentFlag : paymentFlag
                            });
                        }

                    }

                    
                } else {
                    this.setState({
                        notAuthorisedPerson : true,
                        loaderShow: false
                    });
                }
            })
            .catch(error => {
                console.log(error);
            })

    }

    getUserDataByEmail = (email) =>{
        let cookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM'))//cookies.get('STATE_PARAM', false);

        let URL=''
        //let subId=localStorage.getItem("cognitoUsername")
        if(cookiesData && cookiesData.isAgent){
            URL=configuration.baseUrl + '/setupfamily/getMemberBySubID/' +cookiesData.subID
        }else{
           URL= configuration.baseUrl + '/setupfamily/getMemberByEmail/' + email
        }
        axios.get(URL)
            .then(response => {
                if(response.data.response){
                    let data = JSON.parse(JSON.stringify(response.data.response));
                    this.props.setSubId(data.subId, data.email, data.firstName + ' ' + data.lastName);
                    const { prefix, firstName, middleName, lastName, suffix } = data;
                    const displayName = `${prefix || ""} ${firstName || ""} ${middleName || ""} ${lastName || ""} ${suffix || ""}`;
                    let obj = {
                        userName: data.firstName + ' ' + data.lastName,
                        id: data.subId,
                        groupId: data.groupId,
                        email: data.email,
                        phone : data.phone
                    };
                    localStorage.setItem('CurrentLoginUser', JSON.stringify(obj));
                    localStorage.setItem('currentUser', displayName)
                    this.setState({currentUser:displayName})
                }
            });
    }

    enrollment = (event) =>{
        this.setState({enrollFlag : event.detail.flag});
    };

    payment = (event) =>{
        this.setState({paymentFlag : event.detail.flag});
    }

    parseJwt = (id_token) => {

        let base64Url = id_token.split('.')[1];

        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

        let jsonPayload = decodeURIComponent(

            atob(base64)

                .split('')

                .map(function (c) {

                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)

                })
                .join('')
        );

        let token = JSON.parse(jsonPayload);
        localStorage.setItem('userMail', token.email);
        sessionStorage.setItem('userMail', token.email);

        localStorage.setItem('subscriberName', token.name);

        localStorage.setItem('phone', token.phone_number);

        localStorage.setItem('cognitoUsername',token['cognito:username']);
        localStorage.setItem('currentUser',token.given_name + ' ' + token.family_name);

        localStorage.setItem('isLogged', true);
        sessionStorage.setItem('isLogged', true);
        localStorage.setItem('CurrentLoginUser', JSON.stringify(token));

        this.props.setSubId(token.subId, token.email, token.firstName + ' ' + token.lastName);
        let obj = {
            userName: token.firstName + ' ' + token.lastName,
            id: token.sub,
            groupId: token.groupId,
            email: token.email,
            phone : token.phone
        };
        localStorage.setItem('CurrentLoginUser', JSON.stringify(obj));
        return token.email;
    };


    SubmitApplictaion=(event)=>{
        this.setState({optFlag : event.detail.flag});
    }  
// 21 may  comment section +2 
    handleNext = () => {  
        // if(this.state.isChangeProgram || this.state.isHouseholdUpdate){//ReEnrollment
        //         if(this.state.activeStep === 6 && this.state.notHL)
        //             this.setState({
        //                 activeStep: this.state.activeStep + 2
        //             });
        //         else  if(this.state.activeStep === 5 && !this.state.notHL)
        //             this.setState({
        //                 activeStep: this.state.activeStep + 2
        //             });
        //         else{
        //             let activeStep;
        //             activeStep = this.state.activeStep + 1;
        //             const steps = this.getSteps().length;
        //             if (this.state.activeStep < steps - 1) {
        //                 this.setState({
        //                     activeStep
        //                 });
        //             } else {
        //                 this.setState({
        //                     activeStep
        //                 });
        //             }
        //         }
        // }else{
        if(this.state.activeStep === this.getStepIndex('SETUP_FAMILY')){
            this.getNameUpdated()
        }
        let activeStep;
        activeStep = this.state.activeStep + 1;
        if (this.state.isEmployer && activeStep === this.getStepIndex('CHECK_ELIGIBILITY')) {
            activeStep = this.getStepIndex('REVIEW_CHOICES');
        }
        // stepCode reflects the step the member is now on (the one being entered), not the one just completed.
        this.saveStepperProgress(activeStep);
        const steps = this.getSteps().length;
        if (this.state.activeStep < steps - 1) {
            this.setState({
                activeStep
            });
        } else {
            this.setState({
                activeStep
            });
        }
    // }
    };
    getNameUpdated = () =>{
        let cookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM'));
        let URL;
        if(cookiesData.isAgent){
            URL=configuration.baseUrl + '/setupfamily/getMemberBySubID/'+cookiesData.subID
        }else{
            URL=configuration.baseUrl + '/setupfamily/getMemberByEmail/'+cookiesData.user_subId
        }
        axios.get(URL)
        .then(response => {
            if(response.data.response){
                let data = JSON.parse(JSON.stringify(response.data.response));
                const { prefix, firstName, middleName, lastName, suffix } = data;
                const displayName = `${prefix ? prefix + ' ' : ''}${firstName} ${middleName ? middleName + ' ' : ''}${lastName}${suffix ? ' ' + suffix : ''}`;
                this.setState({
                    currentUser :  displayName,
                });
            }
        })
      }
    handlejumpfive=()=>{
        let activeStep;
        activeStep = this.state.activeStep - 1;
        const steps = this.getSteps().length;
        if (this.state.activeStep < steps - 1) {
            this.setState({
                activeStep
            });
        } else {
            this.setState({
                activeStep
            });
        }
    }
    handlePrevious = () => {
        console.log('============== handlePrevious =================');
        console.log(this.state.activeStep);
        let activeStep;
        activeStep = this.state.activeStep - 1;
        if (this.state.isEmployer && activeStep === this.getStepIndex('CHECK_ELIGIBILITY')) {
            activeStep = this.getStepIndex('CHECK_ELIGIBILITY') - 1;
        }
        this.saveStepperProgress(activeStep);
        this.setState({
            activeStep
        });
    }


    handleStep = step => () => {
        if (this.state.isEmployer && step === this.getStepIndex('CHECK_ELIGIBILITY')) {
            return;
        }
        let cookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM'))
        if(this.state.isChangeProgram){//ReEnrollment
            for(var i = 0; i < this.state.ChangeProgramCount.length; i++)
                if(this.state.ChangeProgramCount[i] === step && this.state.activeStep > step){
                this.saveStepperProgress(this.state.ChangeProgramCount[i]);
                this.setState({
                    activeStep: this.state.ChangeProgramCount[i],
                    openedPopoverId: null,
                    anchorEl: null,
                })
                }
        }else if(this.state.isHouseholdUpdate && (this.state.reenrollmentFlag || (cookiesData && (cookiesData.fromMember || cookiesData.isAgent)))){//ReEnrollment
            for(var i = 0; i < this.state.HouseholdUpdateCount.length; i++)
                if(this.state.HouseholdUpdateCount[i] === step && this.state.activeStep > step){
                this.saveStepperProgress(this.state.HouseholdUpdateCount[i]);
                this.setState({
                    activeStep: this.state.HouseholdUpdateCount[i],
                    openedPopoverId: null,
                    anchorEl: null,
                })
                }
        }else{
        if (this.state.activeStep > step) {
            if(this.state.enrollFlag && this.state.paymentFlag){
                this.setState({
                    activeStep: this.state.activeStep,
                    openedPopoverId: null,
          			anchorEl: null,
                });
            } else if(!this.state.paymentFlag && this.state.enrollFlag) {
                // Payment is no longer collected in this flow; land on the final step instead.
                localStorage.removeItem('PAYMENT_ERROR');
                this.saveStepperProgress(this.getStepIndex('SUBMIT_APPLICATION'));
                this.setState({
                    activeStep: this.getStepIndex('SUBMIT_APPLICATION'),
                    openedPopoverId: null,
                    anchorEl: null,
                })
            } else {
                localStorage.removeItem('PAYMENT_ERROR');
                this.saveStepperProgress(step);
                this.setState({
                    activeStep: step,
                    openedPopoverId: null,
          			anchorEl: null,
                });
            }
        }  }
    };

    handleOpen = () => {
        this.setState({
            modalOpen: true,
            loaderShow: true
        });
        fetch(configuration.baseUrl + '/enrollment/getOptoutReasons')
            .then((response) => response.json())
            .then(response => {
                if (response.response) {
                    this.setState({
                        optReasonList: response.response,
                        modalOpen: true,
                        optReason: '',
                        otherReason: '',
                        formValid : true,
                        loaderShow: false,
                        disOtReason : true,
                    });
                }
            })
            .catch(error => {
                this.setState({
                    modalOpen: true,
                    loaderShow: false,
                    optReason: '',
                    otherReason: '',
                    formValid : true,
                    disOtReason : true
                });
            })

    };

    optoutCancelHandler = () => {
        this.state.optReason = '';
        this.state.otherReason = '';
        this.state.modalOpen = false;
        this.setState({
            refresh: true,
        })
    }



    optoutSubmitHandler = () => {
        let data = {
            subId: this.props.subId,
            optReason: this.state.optReason,
            otherReason: this.state.otherReason
        };
        this.setState({
            loaderShow: true
        })
        axios.post(configuration.baseUrl + '/enrollment/saveMemberOptout', data)
            .then(response => {
                this.state.modalOpen = false;
                this.setState({
                    modalOpen: false,
                    loaderShow: false,
                })
            })
            .catch(error => {
                console.log(error);
            })
    }

    handleClose = () => {
        this.setState({
            refresh: true,
            modalOpen : false
        })
    };

    otherOptingReasonChangeHandler = (event,name) => {
        event.preventDefault();
        let txtVal = event.target.value;

        if(txtVal !== '' && this.state.isReasonsReq){
            if (txtVal.match(/^[a-zA-Z ]*$/)) {
                this.setState({ errorText: '', isValid : false, otherReason : txtVal, formValid : false});
            } else {
                this.setState({errorText : 'Please enter valid reason', isValid : true, otherReason : txtVal, formValid : true});
            }
        } else {
            if(this.state.isReasonsReq){
                this.setState({errorText : 'Reason is required', isValid : true, otherReason : txtVal, formValid : true});
            } else {
                this.setState({errorText : '', isValid : false, otherReason : txtVal, formValid : false});
            }
        }
    }

    optingReasonChangeHandler = (event, name) => {
        let value = event.target.value;
        let opText = this.state.optReasonList.find((obj) => obj.id == value);

        this.state[name] = value;        
        if(opText && (opText.reasondCode === 'None' || opText.reasondCode === 'Prefer not to answer' || opText.reasondCode === 'Other reason')){
            this.setState({
                isReasonsReq : false,
                formValid : false,
                optReason : value,
                isValid : false,
                errorText : '',
                disOtReason : false
            })
        } else  {
            this.setState({
                isReasonsReq : true,
                formValid : true,
                optReason : value,
                isValid : false,
                disOtReason : false
            })
        }
    }

    render() {
        const { classes } = this.props;
        const open = this.state.anchorEl === null ? false : true;
        const id = this.state.open ? "simple-popper" : null;
        const { anchorEl, openedPopoverId } = this.state;
        let cookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM'));
        const familyStepName = cookiesData && (cookiesData.clientId == '5742' || cookiesData.clientId == '4599') ? 'Set up Member' : 'Set up Family';
        const multi = this.state.notHL ? [
          {
            _id: 0,
            name: familyStepName,
            hoverText: "Tell us who is joining the program.",

          },
          {
            _id: 1,
            name: 'Select Program',
            hoverText: "Choose the sharing program that’s best for you.",

          },
          {
              _id: 2,
              name: 'Select Add-Ons',
              hoverText: "Choose the add-ons that’s best for you.",

          },
          {
            _id: 3,
            name: 'Check Eligibility',
            hoverText: "Medical questions to confirm everyone is eligible for health sharing.",

          },
          {
              _id: 4,
              name: 'Review Choices',
              hoverText: "Review the choices you've made before proceeding.",

          },
          {
            _id: 5,
            name: 'Submit Application',
            hoverText: "Privacy and compliance questions and the final submission of your application.",

          },

        ] : [
            {
              _id: 0,
              name: familyStepName,
              hoverText: "Tell us who is joining the program.",

            },
            {
              _id: 1,
              name: 'Select Program',
              hoverText: "Choose the sharing program that’s best for you.",

            },
            {
                _id: 2,
                name: 'Review Choices',
                hoverText: "Review the choices you've made before proceeding.",

            },
            {
              _id: 3,
              name: 'Submit Application',
              hoverText: "Privacy and compliance questions and the final submission of your application.",

            },

          ]



        const steps = this.getSteps();
        const { activeStep } = this.state;
        let currentScreen;
        if (this.state.userLoggedIn) {
            // Cognito self-service members skip the multi-step wizard entirely. They land on
            // the Enrollments summary first, then move to Submit Application (Terms + e-sign)
            // once they click ENROLL against a product.
            currentScreen = this.state.showEnrollmentSummary
                ? <EnrollmentSummary onEnrollClick={this.handleEnrollProduct}></EnrollmentSummary>
                : <SubmitApplication backClick={() => this.setState({ showEnrollmentSummary: true })} isAgent={this.state.isAgent} activeStep={this.state.activeStep} enrollingStepperType={this.state.enrollingStepperType} onClick={this.handleNext} handlePrev={() => this.setState({ showEnrollmentSummary: true })} onEnrollmentSubmitted={() => this.setState({ showEnrollmentSummary: true })} agentDetails={this.state.STATE_PARAM} reEnroll={this.state.isChangeProgram || this.state.isHouseholdUpdate}></SubmitApplication>;
        } else if (this.state.activeStep === this.getStepIndex('SETUP_FAMILY')) {
            currentScreen = <SetupFamily isEmployer={this.state.isEmployer} onClick={this.handleNext} activeStep={this.state.activeStep} reEnroll={this.state.isChangeProgram || this.state.isHouseholdUpdate}></SetupFamily>;
        } else if (this.state.activeStep === this.getStepIndex('SELECT_PROGRAM')) {
            currentScreen = <PlanSelection isEmployer={this.state.isEmployer} onClick={this.handleNext} handlePrev={this.handlePrevious} activeStep={this.state.activeStep} isChangeProgram = {this.state.isChangeProgram} isHouseholdUpdate = {this.state.isHouseholdUpdate}></PlanSelection>;
        } else if (this.state.notHL && this.state.activeStep === this.getStepIndex('SELECT_ADDONS')) {
            currentScreen = <AddOnsScreen onClick={this.handleNext} handlePrev={this.handlePrevious} activeStep={this.state.activeStep}></AddOnsScreen>;
        } else if (this.state.notHL && this.state.activeStep === this.getStepIndex('CHECK_ELIGIBILITY')) {
            currentScreen = <Eligibility isAgent={this.state.isAgent} activeStep={this.state.activeStep} onClick={this.handleNext} handlePrev={this.handlePrevious} reEnroll={this.state.isChangeProgram || this.state.isHouseholdUpdate}></Eligibility>;
        } else if (this.state.activeStep === this.getStepIndex('REVIEW_CHOICES')) {
            currentScreen = <ReviewChoice reEnroll={this.state.isChangeProgram || this.state.isHouseholdUpdate} activeStep={this.state.activeStep} showHL= {this.state.notHL} onClickjumpfive={this.handlejumpfive} onClick={this.handleNext}></ReviewChoice>;
        } else {
            currentScreen = <SubmitApplication isAgent={this.state.isAgent} activeStep={this.state.activeStep} onClick={this.handleNext} handlePrev={this.handlePrevious} agentDetails={this.state.STATE_PARAM} reEnroll={this.state.isChangeProgram || this.state.isHouseholdUpdate}></SubmitApplication>;
        }

        var enables =
            this.state.isChangeProgram ?
                this.state.notHL ? [false, false, true, true, true, true] : [false, true, true, true] :
            this.state.isHouseholdUpdate ?
                this.state.notHL ? [true, true, true, true, true, true] : [true, true, true, true] :
            false;

        return (
          <div>
            <Header showEnrollmentSummary={this.state.showEnrollmentSummary}></Header>
            {this.state.loaderShow ? <Loader></Loader> : ""}

            {(this.state.userLoggedIn || this.state.agentLoggedIn) &&
            !this.state.notAuthorisedPerson ? (
              <div id="enrollDiv" style={{
                minHeight: 'calc(100vh - 80px)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}>
                <div
                  style={{
                    marginTop: "30px",
                    width: "95.2%",
                    marginLeft: "2.4%",
                    // marginRight: "2.4%",
                    // paddingBottom: "24%",
                  }}
                >
                  {/* <div style={customStyle.welcomeMessage}>
                    Hello, {this.state.currentUser}
                  </div> */}
                  {!this.state.userLoggedIn && <div
                    style={{
                      marginTop: "31px",
                      width: "100%",
                      height: "14.2%",
                      backgroundColor: "#ffffff",
                      overflowX: "auto",
                    }}
                  >
                    <Stepper
                      alternativeLabel={true}
                      activeStep={activeStep}
                      classes={{ root: classes.MuiPaperRoot }}
                      orientation="horizontal"
                      style={{width: window.innerWidth < 768 ? 'max-content': "100%" }}
                    >
                      {multi.map((label, index) => {
                        const isDisabledForEmployer =
                          this.state.isEmployer &&
                          label.name === "Check Eligibility";
                        return (
                        <StyleTooltip
                          title={
                            isDisabledForEmployer
                              ? "Not applicable to Employers"
                              : label.hoverText
                          }
                          key={index}
                          disableFocusListener
                          placement="top"
                          open={openedPopoverId === label._id}
                        >
                          <Step
                            key={label._id}
                            active={
                              isDisabledForEmployer
                                ? false
                                : enables !== false
                                ? enables[index]
                                : index === this.state.activeStep
                            }
                            completed={
                              isDisabledForEmployer
                                ? false
                                : enables !== false
                                ? enables[index]
                                  ? index < this.state.activeStep
                                  : false
                                : index < this.state.activeStep
                            }
                          >
                            <StepLabel
                              onMouseEnter={(e) =>
                                this.handlePopoverOpen(e, label._id)
                              }
                              onClick={
                                isDisabledForEmployer
                                  ? undefined
                                  : this.handleStep(index)
                              }
                              onMouseLeave={() => this.handlePopoverClose()}
                              style={{
                                cursor: isDisabledForEmployer
                                  ? "not-allowed"
                                  : "pointer",
                                opacity: isDisabledForEmployer ? 0.5 : 1,
                              }}
                              StepIconProps={{
                                classes: {
                                  completed: classes.completed,
                                  active: classes.active,
                                },
                              }}
                            >
                              {label.name}
                            </StepLabel>
                          </Step>
                        </StyleTooltip>
                        );
                      })}
                    </Stepper>
                  </div>}
                  <div style={customStyle.mainArea}>
                    <div style={{ flex: "1 1 auto", display: "flex", flexDirection: "column" }}>{currentScreen}</div>
                    <div
                      style={customStyle.chatBottomWrp}
                      hidden={this.state.isAgent}
                    >
                      {/* <ChatButton></ChatButton> */}
                    </div>
                  </div>
                
                </div>

                <div style={mainClasses.optOut}>

                  <div style={mainClasses.copyRightText}>
                        {copyrightText()}
                  </div>
                  {/*<Modal size="xs" show={this.state.modalOpen} onHide={(event) => this.optoutCancelHandler(event)}>
                                    <Modal.Header style={customStyle.modal_header} closeButton>
                                        <Modal.Title>Opt-out</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body style={{ 'maxHeight': '450px', 'overflowY': 'auto',textAlign : 'justify', wordSpacing:'2px' }}>
                                        {
                                            this.state.loaderShow ? <Loader></Loader> : ''
                                        }
                                        <span style={customStyle.QuickQtTopRightText21}>{i18n.t('ENROLLMENT.TITLE')}</span>
                                        <form>
                                            <div style={{ display: 'flex', width: '100%',marginTop:'10px' }}>
                                                <div>
                                                    <FormControl variant="filled" className={classes.formControl}>
                                                        <CustomTextField select variant='filled' label='Reason for opting-out ' id="demo-simple-select-filled" value={this.state.optReason} onChange={(event) => this.optingReasonChangeHandler(event)} required>
                                                            {
                                                                this.state.optReasonList.map((key, index) => (
                                                                    <MenuItem key={key.id} name={key.reasondCode} value={key.id}>{key.reasondCode}</MenuItem>

                                                                ))
                                                            }
                                                        </CustomTextField>
                                                    </FormControl>
                                                </div>
                                                <div style={{ width: '100%' }}>
                                                    <CustomTextField id="filled-required" label="Other reason" margin="normal" variant="filled" autoComplete="off" style={{margin: '0px'}} disabled={this.state.disOtReason} value={this.state.otherReason} onChange={(event) => this.otherOptingReasonChangeHandler(event)} required={this.state.isReasonsReq} helperText= {this.state.errorText} error={this.state.isValid} InputLabelProps={{style: {color:this.state.isValid?'#FA1515':''}}}/>
                                                </div>
                                            </div>
                                        </form>

                                    </Modal.Body>
                                    <Modal.Footer>
                                        <WizardButton onClick={(event) => this.optoutCancelHandler(event)} style={customStyle.m10}>
                                            {i18n.t('BUTTON.CANCEL')}
                                        </WizardButton>
                                        <WizardButton disabled={this.state.formValid} onClick={this.optoutSubmitHandler} style={customStyle.m10}>
                                            {i18n.t('BUTTON.SUBMIT')}
                                        </WizardButton>
                                    </Modal.Footer>
                                </Modal>

                                 <span style={{ lineHeight: '16px', fontSize: '14px', marginLeft: '24px' }}>{i18n.t('ENROLLMENT.OPT')}</span>
                                 <CustomButton style={mainClasses.caption} onClick={this.handleOpen} disabled={this.state.optFlag}>
                                 {i18n.t('BUTTON.OPTOUT')}
                                 </CustomButton>*/}
                  <span
                    style={{
                      lineHeight: "16px",
                      fontSize: "11px",
                    //   marginLeft: "24px",
                      float: "right",
                    //   marginTop: "11px",
                      display: "inline-block",
                      color: "#333",
                    }}
                  >
                
                  </span>
                  {this.state.STATE_PARAM && (
                    <span
                      style={{
                        marginRight: "0%",
                        float: "right",
                        fontSize: "10px",
                        // marginTop: "14px",
                        display: "inline-block",
                        fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                        color: "#333",
                      }}
                    >
                      CID: {this.state.STATE_PARAM.clientId}, OID:
                      {this.state.STATE_PARAM.associationId}, BID:
                      {this.state.STATE_PARAM.brokerId}
                      {sessionStorage.getItem("EMP_NAME") ? (
                        <> , EID : {sessionStorage.getItem("EMP_NAME")} </>
                      ) : (
                        ""
                      )}{" "}
                          {version("enroll")}
                    </span>
                  )}
                </div>
              </div>
            ) : (
              <div id="enrollDiv">
                <div
                  style={{
                    marginTop: "30px",
                    width: "95.2%",
                    marginLeft: "2.4%",
                    marginRight: "2.4%",
                    fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                  }}
                >
                  <div style={{ width: "55%", margin: "20%" }}>
                    {/* <h4>Oops! Something's not right.</h4>
                    Please go back to the email and click on the link to
                    self-enroll. If you're still having trouble, call us on
                    (800) 921-4505. */}
                  </div>
                </div>
              </div>
            )}
          </div>
        );
    }
}

Enrollment.propTypes = {
    classes: PropTypes.object
};

const mapStateToProps = state => {
    return {
        subId: state.subId,
        email: state.email,
        userName: state.userName,
        isLogged : state.isLogged
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setSubId: (subId, email, userName) => dispatch({ type: 'SET_MEMBER_ID', subId: subId, email: email, userName: userName, isLogged : sessionStorage.getItem('isLogged') })
    }
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Enrollment));